module.exports = __webpack_public_path__ + "static/media/Spider-Man_PS4_Selfie_Photo_Mode_LEGAL.918930b3.jpg";